import Edit from "./Edit";
import AdminWallet from "./components/AdminWallet/AdminWallet";
import Profile from "./components/Profile/Profile";
import PostsEvents from "./components/PostsEvents/PostsEvents";
import { Events, Posts } from "./components/PostsEvents/";

export { PostsEvents, AdminWallet, Profile, Events, Posts };
export default Edit;
